import { renderList as _renderList, Fragment as _Fragment, openBlock as _openBlock, createElementBlock as _createElementBlock, toDisplayString as _toDisplayString, pushScopeId as _pushScopeId, popScopeId as _popScopeId } from "vue";

const _withScopeId = n => (_pushScopeId("data-v-4f808bce"), n = n(), _popScopeId(), n);

const _hoisted_1 = ["onClick"];
export default {
  props: {
    list: Array
  },

  setup(__props) {
    const openLink = item => {
      if (item.jumpUrl && item.jumpUrl.length > 0) {
        location.href = item.jumpUrl;
      }
    };

    return (_ctx, _cache) => {
      return _openBlock(true), _createElementBlock(_Fragment, null, _renderList(__props.list, (item, index) => {
        return _openBlock(), _createElementBlock("div", {
          class: "link-cell",
          key: index,
          onClick: $event => openLink(item)
        }, _toDisplayString(item.urlName), 9, _hoisted_1);
      }), 128);
    };
  }

};